(function () {
    // alert('Share Cart functionality Set');

    var SHARE_TITLE = 'Check out this cart from Universal Paving';
    var SPLIT_FEE_HANDLE = 'split-product-fee';
    var MESSAGE_TIMEOUT = 4000;
    var SHARE_PARAM = 'shared_cart';
    var MAX_SHARED_LINES = 50;

    // Untouched fetch: internal cart writes must bypass the add-to-cart interceptor further down.
    var rawFetch = window.fetch.bind(window);

    var isSharing = false;
    var hideMessageTimer = null;

    function getRoot() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function getCartEndpoint() {
        return getRoot() + 'cart.js';
    }

    function setMessage(messageEl, text) {
        if (!messageEl) return;
        if (hideMessageTimer) clearTimeout(hideMessageTimer);

        if (!text) {
            messageEl.hidden = true;
            messageEl.textContent = '';
            return;
        }

        messageEl.textContent = text;
        messageEl.hidden = false;
        hideMessageTimer = setTimeout(function () {
            messageEl.hidden = true;
            messageEl.textContent = '';
        }, MESSAGE_TIMEOUT);
    }

    function buildShareUrl(cart, fromDrawer) {
        var parts = [];

        (cart.items || []).forEach(function (item) {
            if (!item || !item.variant_id || !item.quantity) return;
            if (item.handle === SPLIT_FEE_HANDLE) return;
            parts.push(item.variant_id + ':' + item.quantity);
        });

        if (!parts.length) return null;

        // A /cart/ID:qty permalink makes Shopify replace the recipient's cart server-side before any JS runs,
        // so the link points at the plain cart page and the items travel in a query param instead.
        // handleIncomingSharedCart() then decides what to do with them.
        // Links created from the cart drawer open the store root so the recipient's drawer shows the options.
        return window.location.origin + getRoot() + (fromDrawer ? '' : 'cart') + '?' + SHARE_PARAM + '=' + parts.join(',');
    }

    function copyToClipboard(url, messageEl) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(url).then(
                function () {
                    setMessage(messageEl, 'Cart link copied!');
                },
                function () {
                    setMessage(messageEl, 'Could not copy the link automatically. Long-press or select the link to copy it.');
                }
            );
        }

        setMessage(messageEl, 'Copy this link: ' + url);
        return Promise.resolve();
    }

    function handleShareCart(button) {
        if (isSharing) return;

        var shareHost = button.closest('[data-share-cart]');
        var messageEl = (shareHost && shareHost.querySelector('#share-cart-message')) || document.getElementById('share-cart-message');
        var fromDrawer = !!button.closest('cart-drawer');

        isSharing = true;
        button.disabled = true;
        setMessage(messageEl, null);

        fetch(getCartEndpoint(), { headers: { Accept: 'application/json' } })
            .then(function (response) {
                if (!response.ok) throw new Error('cart_fetch_failed');
                return response.json();
            })
            .then(function (cart) {
                var shareUrl = buildShareUrl(cart, fromDrawer);

                if (!shareUrl) {
                    setMessage(messageEl, 'Your cart is empty, so there is nothing to share.');
                    return null;
                }

                if (navigator.share) {
                    return navigator
                        .share({
                            title: SHARE_TITLE,
                            text: SHARE_TITLE,
                            url: shareUrl,
                        })
                        .catch(function (shareError) {
                            if (shareError && shareError.name === 'AbortError') return null;
                            return copyToClipboard(shareUrl, messageEl);
                        });
                }

                return copyToClipboard(shareUrl, messageEl);
            })
            .catch(function () {
                setMessage(messageEl, 'Unable to generate a cart link right now. Please try again.');
            })
            .finally(function () {
                isSharing = false;
                button.disabled = false;
            });
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest && event.target.closest('#share-cart-button');
        if (!button) return;
        handleShareCart(button);
    });

    // ------------------------------------------------------------------------------------------------
    // Incoming shared cart: /cart?shared_cart=VARIANT:QTY,VARIANT:QTY
    // ------------------------------------------------------------------------------------------------

    var isApplying = false;

    function parseSharedItems(raw) {
        var totals = {};
        var order = [];

        String(raw || '')
            .split(',')
            .forEach(function (part) {
                var pair = part.split(':');
                var id = /^\d+$/.test(pair[0]) ? pair[0] : null;
                var qty = parseInt(pair[1], 10);
                if (!id || !(qty > 0)) return;
                if (!(id in totals)) {
                    totals[id] = 0;
                    order.push(id);
                }
                totals[id] += qty;
            });

        return order.slice(0, MAX_SHARED_LINES).map(function (id) {
            return { id: Number(id), quantity: totals[id] };
        });
    }

    function removeShareParam() {
        try {
            var url = new URL(window.location.href);
            url.searchParams.delete(SHARE_PARAM);
            history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        } catch (e) { }
    }

    function postCart(endpoint, body) {
        return rawFetch(getRoot() + 'cart/' + endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body || {}),
        }).then(function (response) {
            return response.json().then(
                function (data) {
                    if (!response.ok) throw new Error(data.description || data.message || 'cart_request_failed');
                    return data;
                },
                function () {
                    if (!response.ok) throw new Error('cart_request_failed');
                    return {};
                }
            );
        });
    }

    function addItems(items) {
        return postCart('add.js', { items: items });
    }

    // Rebuilds the add.js payload for the existing lines, keeping properties and selling plans.
    function snapshotItems(cart) {
        return (cart.items || []).map(function (item) {
            var line = { id: item.variant_id, quantity: item.quantity };
            if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
                line.selling_plan = item.selling_plan_allocation.selling_plan.id;
            }
            return line;
        });
    }

    function goToCart() {
        window.location.assign(getRoot() + 'cart');
    }

    // The cart drawer is used on every page except the cart page itself.
    function getCartDrawer() {
        var onCartPage = window.location.pathname.replace(/\/+$/, '') === (getRoot() + 'cart').replace(/\/+$/, '');
        var drawer = document.querySelector('cart-drawer');
        var cartType = window.themeVariables && themeVariables.settings && themeVariables.settings.cartType;
        return !onCartPage && drawer && cartType === 'drawer' ? drawer : null;
    }

    // Immediate feedback while a cart swap/conversion runs: the page loading bar plus a dimmed, non-clickable drawer,
    // so stale cart contents are never presented as the current state.
    function setCartBusy(busy) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-share-cart-busy', busy);
        document.documentElement.dispatchEvent(new CustomEvent(busy ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true }));
    }

    // The theme fades the drawer body/footer parts to opacity 0 when the cart empties and only fades them back in on the
    // next open. Re-rendering with items right after (auto-conversion) would leave the footer invisible, so clear it.
    function resetDrawerParts(drawer) {
        if (!drawer || !drawer.shadowRoot) return;
        Array.prototype.forEach.call(drawer.shadowRoot.querySelectorAll('[part="body"], [part="footer"]'), function (part) {
            part.style.opacity = '';
            part.style.transform = '';
        });
    }

    // Last item_count announced by the theme's own "cart:change" event. Lets the drawer tabs / auto-conversion skip an
    // extra cart.js round trip right after the theme already told us the new cart.
    var announcedCount = null;

    function takeAnnouncedCount() {
        var entry = announcedCount;
        announcedCount = null;
        return entry && Date.now() - entry.at < 5000 ? entry.count : null;
    }

    // One request that both returns the updated cart and renders the drawer section (same mechanism the theme uses for
    // line changes), instead of cart:refresh => section fetch + several cart.js fetches.
    function getBundledSections() {
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        return sections;
    }

    function announceCartChange(cart, keepClosed) {
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: keepClosed ? 'share-cart:refresh' : 'variant:add', cart: cart },
            })
        );
    }

    // When the add.js call that filled the cart already returned the rendered drawer (see addItemsLenient), it is kept
    // here for a moment so no further request is needed to render it.
    var bundledCart = null;

    function refreshDrawerInOneRequest(keepClosed) {
        var ready = bundledCart;
        bundledCart = null;
        if (ready && Date.now() - ready.at < 5000) {
            announceCartChange(ready.cart, keepClosed);
            return Promise.resolve();
        }

        return postCart('update.js', { sections: getBundledSections().join(',') }).then(function (cart) {
            if (!cart || !cart.sections) throw new Error('no_sections');
            announceCartChange(cart, keepClosed);
        });
    }

    // After the Shopify cart changed: re-render + open the drawer when there is one, otherwise go to the cart page.
    function showCartResult(keepClosed) {
        var drawer = getCartDrawer();
        if (!drawer) {
            goToCart();
            return Promise.resolve();
        }
        return refreshDrawerInOneRequest(keepClosed)
            .catch(function () {
                // Fallback: the theme's own refresh.
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                if (typeof window.UniversalPavingFetchAndRefreshCart === 'function') window.UniversalPavingFetchAndRefreshCart();
                if (!keepClosed && typeof drawer.show === 'function') drawer.show();
            })
            .then(function () {
                setTimeout(function () {
                    resetDrawerParts(drawer);
                    setCartBusy(false);
                }, 100);
            });
    }

    // Option 1: clear the cart, then add the shared items. If adding fails the original cart is restored.
    function clearAndApply(existingCart, sharedItems) {
        var snapshot = snapshotItems(existingCart);

        return postCart('clear.js')
            .then(function () {
                return addItems(sharedItems);
            })
            .catch(function (error) {
                return postCart('clear.js')
                    .then(function () {
                        return snapshot.length ? addItems(snapshot) : null;
                    })
                    .catch(function () { })
                    .then(function () {
                        throw error;
                    });
            });
    }

    // ------------------------------------------------------------------------------------------------
    // Option 3: separate carts.
    // Shopify has a single cart per session, so it always holds the ACTIVE cart (this is what checkout uses).
    // The other cart is parked in localStorage as a plain list of lines and swapped in when its tab is clicked.
    // Stored shape: { active: 'existing'|'shared', other: { key: 'shared'|'existing', items: [...] } }
    // Only variant ids, quantities, properties and selling plan ids are stored: no customer data.
    // ------------------------------------------------------------------------------------------------

    var SEPARATE_KEY = 'up_separate_carts';
    var CART_LABELS = { existing: 'Existing Cart', shared: 'Shared Cart' };

    function readSeparateState() {
        try {
            var state = JSON.parse(localStorage.getItem(SEPARATE_KEY));
            if (state && CART_LABELS[state.active] && state.other && CART_LABELS[state.other.key] && Array.isArray(state.other.items)) {
                return state;
            }
        } catch (e) { }
        return null;
    }

    function writeSeparateState(state) {
        try {
            if (state) localStorage.setItem(SEPARATE_KEY, JSON.stringify(state));
            else localStorage.removeItem(SEPARATE_KEY);
        } catch (e) { }
    }

    function sumQuantity(items) {
        return items.reduce(function (total, item) {
            return total + (item.quantity || 0);
        }, 0);
    }

    // Option 3 entry: the existing cart stays the live Shopify cart (so every normal add/update/remove and checkout
    // hits it), and the shared items are parked untouched until their tab is opened.
    function separateAndApply(existingCart, sharedItems) {
        writeSeparateState({ active: 'existing', other: { key: 'shared', items: sharedItems } });
        return Promise.resolve();
    }

    // Adds lines in one call; if that fails (e.g. one line is out of stock) falls back to line by line.
    // Resolves with the number of lines that could not be added.
    // Parked lines are stored top-to-bottom as the cart displayed them, but Shopify lists the most recently added line
    // first, so they are added in reverse to keep the same order on screen after every swap/conversion.
    function addItemsLenient(items) {
        if (!items.length) return Promise.resolve(0);
        items = items.slice().reverse();
        bundledCart = null;

        // The live cart is empty when this runs, so the lines added here ARE the whole cart: ask add.js to render the
        // drawer in the same response and skip a separate refresh request.
        var sections = getCartDrawer() ? getBundledSections() : [];
        var payload = { items: items };
        if (sections.length) payload.sections = sections.join(',');

        return postCart('add.js', payload).then(
            function (result) {
                if (result && result.sections && result.items) {
                    bundledCart = {
                        at: Date.now(),
                        cart: { items: result.items, item_count: sumQuantity(result.items), sections: result.sections },
                    };
                }
                return 0;
            },
            function () {
                var skipped = 0;
                return items
                    .reduce(function (chain, line) {
                        return chain.then(function () {
                            return addItems([line]).catch(function () {
                                skipped += 1;
                            });
                        });
                    }, Promise.resolve())
                    .then(function () {
                        return skipped;
                    });
            }
        );
    }

    // Swaps the live Shopify cart with the parked one. The current lines are parked, so nothing is lost.
    function switchSeparateCart(state) {
        return fetch(getCartEndpoint(), { headers: { Accept: 'application/json' } })
            .then(function (response) {
                if (!response.ok) throw new Error('cart_fetch_failed');
                return response.json();
            })
            .then(function (liveCart) {
                var leaving = snapshotItems(liveCart);

                return postCart('clear.js')
                    .then(function () {
                        return addItemsLenient(state.other.items);
                    })
                    .then(function (skipped) {
                        writeSeparateState({ active: state.other.key, other: { key: state.active, items: leaving } });
                        if (skipped) {
                            try {
                                sessionStorage.setItem(SEPARATE_KEY + '_notice', String(skipped));
                            } catch (e) { }
                        }
                    })
                    .catch(function (error) {
                        // Put the cart the customer was viewing back, then report the failure.
                        return postCart('clear.js')
                            .then(function () {
                                return addItemsLenient(leaving);
                            })
                            .catch(function () { })
                            .then(function () {
                                throw error;
                            });
                    });
            });
    }

    // Shared Cart emptied (it is the live cart with 0 lines): bring the Existing Cart back as the normal cart.
    function restoreExistingCart(host, state) {
        if (isApplying) return;
        isApplying = true;
        setCartBusy(true);
        switchSeparateCart(state).then(
            function () {
                if (host.closest('cart-drawer') && getCartDrawer()) {
                    isApplying = false;
                    showCartResult(true);
                } else {
                    goToCart();
                }
            },
            function () {
                isApplying = false;
                setCartBusy(false);
            }
        );
    }

    // Existing Cart emptied while a Shared Cart is parked: the parked lines become the Existing Cart and separate mode
    // ends (so the Shared tab disappears). The live cart is empty at this point, so nothing can be duplicated.
    // Returns true when a conversion was started.
    function autoConvertSharedToExisting(host, count) {
        var state = readSeparateState();
        if (isApplying || count !== 0 || !state || state.active !== 'existing' || !state.other.items.length) return false;

        isApplying = true;
        setCartBusy(true);

        addItemsLenient(state.other.items).then(function (skipped) {
            if (skipped >= state.other.items.length) {
                // Nothing could be added: keep the parked cart rather than losing it.
                isApplying = false;
                setCartBusy(false);
                return;
            }

            writeSeparateState(null);
            if (host && host.closest('cart-drawer') && getCartDrawer()) {
                isApplying = false;
                showCartResult(true);
            } else {
                goToCart();
            }
        });
        return true;
    }

    // The theme announces every AJAX cart change; an emptied Existing Cart converts straight away, before the drawer
    // finishes re-rendering its empty state.
    document.addEventListener('cart:change', function (event) {
        var cart = event.detail && event.detail.cart;
        if (!cart || typeof cart.item_count !== 'number') return;
        announcedCount = { count: cart.item_count, at: Date.now() };
        if (getCartDrawer()) autoConvertSharedToExisting(document.querySelector('cart-drawer'), cart.item_count);
    });

    // New products must always land in the Existing Cart. While the Shared Cart is the live cart, an add-to-cart
    // request first swaps the Existing Cart back in (the shared lines go back to parked storage), then proceeds.
    var restoringPromise = null;
    var CART_ADD_PATTERN = /\/cart\/add(\.js)?$/;

    window.fetch = function (input, init) {
        var args = arguments;
        var url = '';
        try {
            url = new URL(typeof input === 'string' ? input : (input && input.url) || '', window.location.origin).pathname;
        } catch (e) { }

        var state = CART_ADD_PATTERN.test(url) ? readSeparateState() : null;
        if (!state || state.active !== 'shared') return rawFetch.apply(window, args);

        if (!restoringPromise) {
            restoringPromise = switchSeparateCart(state).then(
                function () {
                    restoringPromise = null;
                },
                function (error) {
                    restoringPromise = null;
                    throw error;
                }
            );
        }
        return restoringPromise.then(function () {
            return rawFetch.apply(window, args);
        });
    };

    function renderSeparateTabs(host) {
        var state = readSeparateState();
        if (!state || !host || host.querySelector('.shared-cart-tabs') || host.sharedTabsPending) return;

        // Nothing parked any more: leave separate mode.
        if (!state.other.items.length) {
            writeSeparateState(null);
            return;
        }

        host.sharedTabsPending = true;
        var announced = takeAnnouncedCount();
        var countPromise =
            announced !== null
                ? Promise.resolve(announced)
                : fetch(getCartEndpoint(), { headers: { Accept: 'application/json' } })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (cart) {
                        return cart.item_count;
                    });

        countPromise
            .then(function (count) {
                host.sharedTabsPending = false;
                if (state.active === 'shared' && count === 0) {
                    restoreExistingCart(host, state);
                    return;
                }
                if (autoConvertSharedToExisting(host, count)) return;
                if (!host.querySelector('.shared-cart-tabs')) buildSeparateTabs(host, state, count);
            })
            .catch(function () {
                host.sharedTabsPending = false;
            });
    }

    function buildSeparateTabs(host, state, activeCount) {

        var wrapper = document.createElement('div');
        wrapper.className = 'shared-cart-tabs';
        wrapper.innerHTML =
            '<div class="shared-cart-tabs__list" role="tablist" aria-label="Choose which cart to view"></div>' +
            '<p class="shared-cart-tabs__note text-sm text-subdued"></p>' +
            '<p class="shared-cart-tabs__status text-sm" role="status" aria-live="polite" hidden></p>';

        var list = wrapper.querySelector('.shared-cart-tabs__list');
        var note = wrapper.querySelector('.shared-cart-tabs__note');
        var status = wrapper.querySelector('.shared-cart-tabs__status');
        var tabs = [];

        note.innerHTML = 'Checkout and any changes only apply to the <strong>' + CART_LABELS[state.active] + '</strong> shown below.';

        function makeTab(key, isActive, count) {
            var tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'shared-cart-tabs__tab' + (isActive ? ' is-active' : '');
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.textContent = CART_LABELS[key] + (count === null ? '' : ' (' + count + ')');
            list.appendChild(tab);
            tabs.push(tab);
            return tab;
        }

        var activeTab = makeTab(state.active, true, activeCount);
        var otherTab = makeTab(state.other.key, false, sumQuantity(state.other.items));

        // Keep the same left-to-right order (Existing, Shared) whichever one is active.
        if (state.active === 'shared') list.insertBefore(otherTab, activeTab);

        function setActiveTab(target) {
            tabs.forEach(function (t) {
                var on = t === target;
                t.classList.toggle('is-active', on);
                t.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            var key = target === activeTab ? state.active : state.other.key;
            note.innerHTML = 'Checkout and any changes only apply to the <strong>' + CART_LABELS[key] + '</strong> shown below.';
        }

        otherTab.addEventListener('click', function () {
            if (isApplying) return;
            isApplying = true;
            tabs.forEach(function (t) {
                t.disabled = true;
            });
            status.textContent = 'Switching to your ' + CART_LABELS[state.other.key] + '...';
            status.classList.remove('is-error');
            status.hidden = false;
            // Immediate feedback: move the highlight now instead of after the swap + re-render.
            setActiveTab(otherTab);
            setCartBusy(true);

            switchSeparateCart(state).then(
                function () {
                    if (host.closest('cart-drawer')) {
                        // Drawer: the content is re-rendered (and fresh tabs injected) by the refresh.
                        isApplying = false;
                        showCartResult();
                    } else {
                        goToCart();
                    }
                },
                function () {
                    isApplying = false;
                    setCartBusy(false);
                    setActiveTab(activeTab);
                    tabs.forEach(function (t) {
                        t.disabled = false;
                    });
                    status.textContent = 'Sorry, we could not switch carts. Your current cart has been kept. Please try again.';
                    status.classList.add('is-error');
                }
            );
        });

        // Arrow keys move between tabs, as expected for a tab list.
        list.addEventListener('keydown', function (event) {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            var target = document.activeElement === otherTab ? activeTab : otherTab;
            target.focus();
        });

        try {
            var skipped = sessionStorage.getItem(SEPARATE_KEY + '_notice');
            if (skipped) {
                sessionStorage.removeItem(SEPARATE_KEY + '_notice');
                status.textContent =
                    skipped + ' item(s) could not be added because they are no longer available, so they were left out of this cart.';
                status.hidden = false;
            }
        } catch (e) { }

        // Cart page: sit directly above form.cart-page.cart-page-form (below the title). Drawer: first child.
        var cartForm = host.querySelector(':scope > form.cart-page.cart-page-form');
        host.insertBefore(wrapper, cartForm || host.firstChild);
    }

    // Back/forward cache can show a cart page from before a switch; reload so it matches the real cart.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted && readSeparateState()) window.location.reload();
    });

    // Option 2: add.js merges lines with the same variant (same properties/selling plan) and is all-or-nothing.
    function mergeAndApply(sharedItems) {
        return addItems(sharedItems);
    }

    function buildChoiceDialog() {
        var overlay = document.createElement('div');
        overlay.className = 'shared-cart-choice';
        overlay.innerHTML =
            '<div class="shared-cart-choice__dialog" role="dialog" aria-modal="true" aria-labelledby="shared-cart-choice-title" aria-describedby="shared-cart-choice-text" tabindex="-1">' +
            '<button type="button" class="shared-cart-choice__close" data-shared-cart-cancel aria-label="Close">&times;</button>' +
            '<h2 class="shared-cart-choice__title h4" id="shared-cart-choice-title">Your cart already contains items</h2>' +
            '<p class="shared-cart-choice__text" id="shared-cart-choice-text">Would you like to merge the new cart with the existing one or clear the existing items?</p>' +
            '<div class="shared-cart-choice__actions">' +
            '<button type="button" class="shared-cart-choice__button button" data-shared-cart-action="clear">Clear Existing Cart First</button>' +
            '<button type="button" class="shared-cart-choice__button button" data-shared-cart-action="merge">Merge Carts</button>' +

            (readSeparateState()
                ? ''
                : '<button type="button" class="shared-cart-choice__button button" data-shared-cart-action="separate">Show as Separate Carts</button>') +
            '</div>' +
            '<p class="shared-cart-choice__status text-sm" role="status" aria-live="polite" hidden></p>' +
            '</div>';
        return overlay;
    }

    function showChoiceDialog(existingCart, sharedItems) {
        var previousFocus = document.activeElement;
        var overlay = buildChoiceDialog();
        var dialog = overlay.querySelector('.shared-cart-choice__dialog');
        var statusEl = overlay.querySelector('.shared-cart-choice__status');
        var buttons = overlay.querySelectorAll('button');

        function setBusy(busy) {
            isApplying = busy;
            dialog.setAttribute('aria-busy', busy ? 'true' : 'false');
            overlay.classList.toggle('is-loading', busy);
            Array.prototype.forEach.call(buttons, function (b) {
                b.disabled = busy;
            });
        }

        function setStatus(text, isError) {
            statusEl.textContent = text || '';
            statusEl.hidden = !text;
            statusEl.classList.toggle('is-error', !!isError);
        }

        function close() {
            document.removeEventListener('keydown', onKeydown, true);
            document.documentElement.classList.remove('shared-cart-choice-open');
            overlay.remove();
            if (previousFocus && previousFocus.focus) previousFocus.focus();
        }

        function cancel() {
            if (isApplying) return;
            removeShareParam();
            close();
        }

        function onKeydown(event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                cancel();
                return;
            }
            if (event.key !== 'Tab') return;

            var focusable = Array.prototype.filter.call(buttons, function (b) {
                return !b.disabled;
            });
            if (!focusable.length) {
                event.preventDefault();
                return;
            }
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }

        overlay.addEventListener('click', function (event) {
            if (event.target === overlay || event.target.closest('[data-shared-cart-cancel]')) {
                cancel();
                return;
            }

            var actionBtn = event.target.closest('[data-shared-cart-action]');
            if (!actionBtn || isApplying) return;

            var action = actionBtn.getAttribute('data-shared-cart-action');
            setBusy(true);
            setStatus(
                action === 'clear' ? 'Replacing your cart...' : action === 'merge' ? 'Merging the carts...' : 'Setting up your carts...',
                false
            );

            var operation =
                action === 'clear'
                    ? clearAndApply(existingCart, sharedItems)
                    : action === 'merge'
                        ? mergeAndApply(sharedItems)
                        : separateAndApply(existingCart, sharedItems);

            operation.then(
                function () {
                    // Stay in the busy state while navigating so the buttons cannot be clicked twice.
                    removeShareParam();
                    // Cart page: navigate (buttons stay busy). Drawer: close the dialog, re-render and open the drawer.
                    if (getCartDrawer()) {
                        setBusy(false);
                        close();
                    }
                    showCartResult();
                },
                function (error) {
                    setBusy(false);
                    var detail = error && error.message && error.message !== 'cart_request_failed' ? ' (' + error.message + ')' : '';
                    setStatus('Sorry, we could not add the shared items' + detail + '. Your original cart has been kept. Please try again.', true);
                }
            );
        });

        document.addEventListener('keydown', onKeydown, true);
        document.documentElement.classList.add('shared-cart-choice-open');
        document.body.appendChild(overlay);
        dialog.focus();
    }

    function handleIncomingSharedCart() {
        var params;
        try {
            params = new URLSearchParams(window.location.search);
        } catch (e) {
            return;
        }
        if (!params.has(SHARE_PARAM)) return;

        var sharedItems = parseSharedItems(params.get(SHARE_PARAM));
        if (!sharedItems.length) {
            removeShareParam();
            return;
        }

        // Always read the live cart: the Liquid-rendered cart can be stale after AJAX changes.
        fetch(getCartEndpoint(), { headers: { Accept: 'application/json' } })
            .then(function (response) {
                if (!response.ok) throw new Error('cart_fetch_failed');
                return response.json();
            })
            .then(function (cart) {
                if (!cart.item_count) {
                    // Empty cart: load the shared items straight away, no choice screen.
                    return addItems(sharedItems).then(function () {
                        removeShareParam();
                        return showCartResult();
                    });
                }
                showChoiceDialog(cart, sharedItems);
            })
            .catch(function () {
                window.alert('We could not load the shared cart. Please try the link again.');
            });
    }

    // Cart page tabs.
    renderSeparateTabs(document.querySelector('[data-name="main-cart"] .section-stack'));

    // Cart drawer tabs. The theme re-renders the drawer by replacing its children, which removes the tabs,
    // so they are injected again whenever the drawer content changes.
    function renderDrawerTabs() {
        var drawer = document.querySelector('cart-drawer');
        if (drawer) renderSeparateTabs(drawer);
    }

    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
        renderDrawerTabs();
        new MutationObserver(renderDrawerTabs).observe(drawerEl, { childList: true });
    }

    handleIncomingSharedCart();
})();
